<template>
  <Fragment>
    <template v-if="$route.name !== 'statistics'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <el-tabs
            v-model="activeName"
            type="card"
            style="width: 100%"
            @tab-click="handleActive"
          >
            <el-tab-pane label="数据报表" name="first" :stretch="true">
              <div class="tag-group">
                <span> 产品码扫码:</span>
                <el-tag type="success">扫码总数: {{ scanAllCount }}</el-tag
                >&nbsp;&nbsp;&nbsp;
                <el-tag type="warning">扫码失败增长率: {{ failAddRate }}</el-tag
                >&nbsp;&nbsp;&nbsp;
                <el-tag type="danger">扫码失败总数: {{ failNum }}</el-tag
                >&nbsp;&nbsp;&nbsp;
                <el-tag type="danger">扫码失败率: {{ failRate }}</el-tag
                >&nbsp;&nbsp;
                <el-tag type="success"
                  >生码总量: {{ createQrcodeSumNum }}</el-tag
                >
              </div>
              <br />
              <div class="left">
                <div class="search-name mr-15">
                  <el-radio v-model="yearCheck" label="2020">2020</el-radio>
                  <el-radio v-model="yearCheck" label="2021">2021</el-radio>
                  <el-radio v-model="yearCheck" label="2022">2022</el-radio>
                  <el-radio v-model="yearCheck" label="2023">2023</el-radio>
                </div>
              </div>
              <br />
              <div class="left">
                <div class="search-name mr-15">
                  <el-checkbox-group v-model="monthCheck">
                    <el-checkbox
                      v-for="item in monthOptions"
                      :label="item.value"
                      :key="item.value"
                      >{{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <el-button type="primary" size="medium" @click="getScanRecord"
                  >查询
                </el-button>
              </div>
              <br />
              <div>
                <el-table
                  :data="tableData"
                  style="width: 100%"
                  border
                  show-summary
                  :span-method="objectSpanMethod"
                >
                  <el-table-column
                    prop="systemSourceName"
                    label="系统来源"
                    width="160"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="sceneSource"
                    label="场景来源"
                    width="200"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="scanCount"
                    label="扫码量"
                    width="100"
                    align="center"
                  >
                    <!--                    <template slot-scope="scope">-->
                    <!--                      <el-link-->
                    <!--                        type="primary"-->
                    <!--                        @click="-->
                    <!--                          showMessage(scope.row, '1', scope.row.scanCount)-->
                    <!--                        "-->
                    <!--                        >{{ scope.row.scanCount }}</el-link-->
                    <!--                      >-->
                    <!--                    </template>-->
                  </el-table-column>
                  <el-table-column label="标记扫码解析系统来源" align="center">
                    <el-table-column
                      prop="systemCount"
                      label="1.二维码数据库"
                      width="200"
                      align="center"
                    >
                      <!--                      <template slot-scope="scope">-->
                      <!--                        <el-link-->
                      <!--                          type="primary"-->
                      <!--                          @click="-->
                      <!--                            showMessage(scope.row, '2', scope.row.systemCount)-->
                      <!--                          "-->
                      <!--                          >{{ scope.row.systemCount }}</el-link-->
                      <!--                        >-->
                      <!--                      </template>-->
                    </el-table-column>
                    <el-table-column
                      prop="bigDataCount"
                      label="2.大数据数据库"
                      width="200"
                      align="center"
                    >
                      <!--                      <template slot-scope="scope">-->
                      <!--                        <el-link-->
                      <!--                          type="primary"-->
                      <!--                          @click="-->
                      <!--                            showMessage(scope.row, '3', scope.row.bigDataCount)-->
                      <!--                          "-->
                      <!--                          >{{ scope.row.bigDataCount }}</el-link-->
                      <!--                        >-->
                      <!--                      </template>-->
                    </el-table-column>
                  </el-table-column>

                  <el-table-column label="扫码失败总量" align="center">
                    <el-table-column
                      prop="scanFailCount"
                      label="扫码失败量"
                      width="120"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-link
                          type="primary"
                          @click="
                            showMessage(scope.row, scope.row.scanFailCount, 1)
                          "
                          >{{ scope.row.scanFailCount }}</el-link
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="ifailCount"
                      label="i码制扫码失败量"
                      width="120"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-link
                          type="primary"
                          @click="
                            showMessage(scope.row, scope.row.ifailCount, 2)
                          "
                          >{{ scope.row.ifailCount }}</el-link
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="maFailCount"
                      label="MA码制扫码失败量"
                      width="120"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-link
                          type="primary"
                          @click="
                            showMessage(scope.row, scope.row.maFailCount, 3)
                          "
                          >{{ scope.row.maFailCount }}</el-link
                        >
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column
                    prop="scanFailRate"
                    label="扫码失败率"
                    :fit="true"
                    align="center"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="数据可视化" name="second">
              <div class="left">
                <div class="search-name mr-15">
                  <el-radio v-model="viewCheck" label="2020">2020</el-radio>
                  <el-radio v-model="viewCheck" label="2021">2021</el-radio>
                  <el-radio v-model="viewCheck" label="2022">2022</el-radio>
                  <el-radio v-model="viewCheck" label="2023">2023</el-radio>
                </div>
              </div>
              <br />
              <div class="left">
                <div class="search-name mr-15">
                  系统-场景来源:
                  <el-select v-model="value" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.systemSource"
                      :label="item.systemSource"
                      :value="item.systemSource"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="search-name mr-15">
                  类型:
                  <el-select v-model="typeValue" placeholder="请选择">
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-button
                  type="primary"
                  size="medium"
                  @click="getScanStatisticsView"
                  >查询
                </el-button>
              </div>
              <br />
              <el-row :gutter="20">
                <template>
                  <ve-line
                    :data="chartData"
                    ref="chartsecond"
                    :settings="chartSettings"
                  ></ve-line>
                </template>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </section>
      </div>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "scan",
  components: {
    Breadcrumb,
    Fragment
  },
  watch: {
    activeName(v) {
      this.$nextTick(_ => {
        this.$refs[`chart${v}`].echarts.resize();
      });
    }
  },
  data() {
    return {
      options: [],
      value: "卡萨帝_权益",
      typeOptions: [
        {
          value: "0",
          label: "扫码量"
        },
        {
          value: "1",
          label: "成功量"
        },
        {
          value: "2",
          label: "失败量"
        }
      ],
      typeValue: "0",
      yearCheck: "2020",
      viewCheck: "2020",
      monthCheck: [10, 11],
      monthOptions: [
        { label: "1月", value: 1 },
        { label: "2月", value: 2 },
        { label: "3月", value: 3 },
        { label: "4月", value: 4 },
        { label: "5月", value: 5 },
        { label: "6月", value: 6 },
        { label: "7月", value: 7 },
        { label: "8月", value: 8 },
        { label: "9月", value: 9 },
        { label: "10月", value: 10 },
        { label: "11月", value: 11 },
        { label: "12月", value: 12 }
      ],
      position: 0,
      rowSpanArr: [],
      scanAllCount: "",
      failNum: "",
      failAddRate: "",
      failRate: "",
      createQrcodeSumNum: "",
      labelPosition: "left",
      activeName: "first",
      timeArray: "",
      scanInfo: "",
      tableData: [],
      chartSettings: {
        labelMap: {
          count: "数量"
        },
        yAxisName: ["数量"],
        xAxisName: ["月份"]
      },
      chartData: {
        columns: ["month", "count"],
        rows: []
      }
    };
  },
  methods: {
    handleActive(targetName) {
      let _this = this;
      if (targetName.name === "second") {
        //获取下拉及图表初始值
        _this.getScanStatistics();
      }
    },
    getScanStatistics() {
      let _this = this;
      let param = {
        url: "/api/scan/getScanStatistics"
      };
      _this.$store.dispatch("getScanStatistics", param).then(() => {
        _this.options =
          _this.$store.state.scanStatistics.scanSelectInfo.selectInfo;
        _this.chartData.rows =
          _this.$store.state.scanStatistics.scanSelectInfo.viewInfo;
      });
    },
    getScanStatisticsView() {
      let _this = this;
      let param = {
        url: "/api/scan/getScanStatisticsView",
        params: {
          year: _this.viewCheck,
          systemSource: _this.value,
          flag: _this.typeValue
        }
      };
      _this.$store.dispatch("getScanStatisticsView", param).then(() => {
        _this.chartData.rows =
          _this.$store.state.scanStatistics.scanStatisticsInfo;
      });
    },
    getScanRecord() {
      let _this = this;
      let monthCheck = _this.monthCheck;
      if (monthCheck.length === 0) {
        _this.$message({
          message: "请选择对应的月份",
          type: "error"
        });
        return false;
      }
      let month = _this._.join(monthCheck, ",");
      let param = {
        url: "/api/scan/getScanRecord",
        params: {
          year: _this.yearCheck,
          month: month
        }
      };

      _this.$store.dispatch("getScanRecord", param).then(() => {
        _this.tableData = _this.$store.state.scanStatistics.scanInfo.list;
        _this.scanAllCount =
          _this.$store.state.scanStatistics.scanInfo.scanAllCount;
        _this.failAddRate =
          _this.$store.state.scanStatistics.scanInfo.failAddRate;
        _this.failRate = _this.$store.state.scanStatistics.scanInfo.failRate;
        _this.failNum = _this.$store.state.scanStatistics.scanInfo.failNum;
        _this.createQrcodeSumNum =
          _this.$store.state.scanStatistics.scanInfo.createQrcodeSumNum;
        _this.getRowSpan();
      });
    },
    getRowSpan() {
      let _this = this;
      _this.rowSpanArr = [];
      _this.tableData.forEach((item, index) => {
        if (index == 0) {
          _this.rowSpanArr.push(1);
          _this.position = 0;
        } else {
          if (
            _this.tableData[index].systemSource ==
            _this.tableData[index - 1].systemSource
          ) {
            _this.rowSpanArr[_this.position] += 1; //项目名称相同，合并到同一个数组中
            _this.rowSpanArr.push(0);
            _this.tableData[index].systemSource =
              _this.tableData[index - 1].systemSource;
          } else {
            _this.rowSpanArr.push(1);
            _this.position = index;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 只合并区域位置
      if (columnIndex === 0) {
        const _row = this.rowSpanArr[rowIndex];
        return {
          rowspan: _row, //行
          colspan: 1 //列
        };
      }
    },
    showMessage(row, value, type) {
      if (value != 0) {
        this.$router.push({
          name: "showScanInfo",
          query: {
            sceneSource: row.sceneSource,
            systemSource: row.systemSource,
            year: this.yearCheck,
            month: this._.join(this.monthCheck, ","),
            type: type
          }
        });
      }
    }
  },
  created() {
    let _this = this;
    _this.getScanRecord();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
    .card-content
        display: flex
        align-items: center
        justify-content: space-between

        .left
            display: flex
            margin-top: 1%
        .el-button
            font-size: 14px

        .search-name, .search-code
            font-size: 14px
            display: flex
            align-items: center

            span
                white-space: nowrap

        .numPane
            font-size: 14px
            font-weight: 500
            margin-top: 1%

            .numName
                display: inline

            .allNum
                display: inline
                margin-left: 5%

            .rateNum
                display: inline
                margin-left: 10%

            .failNum
                margin-left: 10.1%
                margin-top: 1%
            .scanRate
                margin-left: 29.2%
                margin-top: -1.2%
    .pagination
        text-align: center
</style>
